import { useEffect, useState } from "preact/hooks";
import { type ContentBlock, dividerLook } from "@fobu/schema";
import { useFormEnv } from "../lib/context";

type DividerBlock = Extract<ContentBlock, { type: "divider" }>;

const COLORS = { neutral: "var(--fb-text)", primary: "var(--fb-primary)", info: "#2563eb", success: "#15803d", warning: "#b45309", danger: "var(--fb-danger)" } as const;

// Symbole nur nachladen, wenn eine Trennlinie eines nutzt.
let icons: Record<string, string> | undefined;
const loadIcons = () => import("./DividerIcons").then((m) => (icons = m.DIVIDER_SVG));

/** Trennlinie: Linienart, Ausprägung, Farbe, Länge, optional Symbol und/oder Text in der Mitte. */
export function Divider({ block }: { block: DividerBlock }) {
  const { tpl } = useFormEnv();
  const [svg, setSvg] = useState(() => icons);
  useEffect(() => {
    if (block.icon && !svg) void loadIcons().then((x) => setSvg(() => x));
  }, [block.icon]);
  const color = block.color ?? "neutral";
  const look = dividerLook(block.strength ?? 2, color === "neutral");
  const text = block.text ? tpl(block.text) : "";
  const deco = !!(block.icon || text);
  const style = { "--d-c": COLORS[color] ?? COLORS.neutral, "--d-w": `${look.px}px`, "--d-o": String(look.opacity) } as Record<string, string>;
  return (
    <div
      role="separator"
      aria-label={text || undefined}
      class={`fb-divider fb-divider--${block.style ?? "solid"} fb-divider--${block.width ?? "full"} fb-divider--sp-${block.spacing ?? "normal"}${deco ? " fb-divider--deco" : ""}${color === "neutral" ? "" : " fb-divider--color"}`}
      style={style}
    >
      <span class="fb-divider-line" />
      {deco && (
        <span class="fb-divider-mark" aria-hidden="true">
          {block.icon && (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" dangerouslySetInnerHTML={{ __html: svg?.[block.icon] ?? "" }} />
          )}
          {text && <span>{text}</span>}
        </span>
      )}
      {deco && <span class="fb-divider-line" />}
    </div>
  );
}
